/**
 * Created by cowens on 12/2/15.
 */

import RunConfigService from './runConfigService.js';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace NUSAnalytics
 */
class NUSAnalytics {
    constructor() {
        this.runConfig = RunConfigService.getRunConfig();
        this.analyticVariableENUMS = {
            CHECKOUTS: "scCheckout", //When the visitor clicks on the checkout page on the cart screen
            REVENUE: "revenue", //Revenue generated (part of the product string)
            UNITS: "units", //The amount of each individual units purchased in an order (part of the product string)
            ORDERS: "purchase", //A count of all order types made on the market sites (part of the product String
            PLACE_ORDER: "nus.event11", //When the place order screen is tapped on the order summary page
            ASSESSMENT_COMPLETE: "assessmentComplete", //When the user finishes their profile
            ASSESSMENT_EDIT: "assessmentEdit", //When the user clicks on the eidt button to edit profile
            CODE_USAGE: "codeUsage", //When the user clicks on the "I already have a code button"
            PRODUCTS: "products", //s.products=";SKU;units;revenue"
            PURCHASE_ID: "purchaseID", //use the order number
            LANGUAGE: "nus.eVar4", //The language of the current page
            MARKET: "nus.eVar6", //The market section of the site where the user is currently located
            PAGE_NAME: "nus.eVar8", //The name of the page that is currently loaded
            UNIQUE_USER_ID: "nus.eVar9", //The ID of the user who is currently logged in
            PIN_RANK: "nus.eVar11", //The current pin rank of the user (subrank from profile, or "none" if guest)
            ORDER_TYPE: "nus.eVar12", //Classification of the type of order placed (standard_order, adr_order, dual_order)
            ORDER_NUMBER: "nus.eVar20", //The order numbers that are given when an order finishes
            EXISTING_PROFILE: "existingProfile", //How many, if any, existing profiles are on the account
            PAGES: "pageName", //The pagename of the loaded page. This should be based on the pathname
            DISTRIBUTOR_ID: "evar9", //Distributor ID of user logged in
            LOGIN_TIME: "evar26", //Login Time
            LOGIN_DAY: "evar27", //Day of the week the log in was done
            PITCH_CREATED: "event50", //Event for when a pitch has been created
            PAGE_LOAD: "evar8", //Page Load (name of page)
            PAGE_LOAD_PROP: "prop8", //Page Load (name of page) -- both PAGE_LOAD and PAGE_LOAD_PROP should be set
            PITCH_SKU: "evar45", //SKU for product included in pitch
            SEARCH_TERM: "evar3", //Term searched for
            DISCOUNT_OPTION: "evar46", //Discount selected for pitch
            ADD_VIDEO: "evar47", //Click on the "Add Video" button
            VIDEO_LENGTH: "evar48", //Length of the video in the pitch
            PITCH_MEDIUM: "evar49", //What they sent the offer with (Facebook, text, etc.) -- This is not possible to detect
            PITCH_ID: "evar50", //ID for the pitch that was sent
            PITCH_DELETE: "event51", //Pitch was deleted
            OFFERS_BUTTON: "evar55", //Button used to get the "Offers" page in Pitch
            PITCH_SENT_DATE: "evar56", //Date pitch sent
            PITCH_SENT_TIME: "evar57", //Time pitch sent
            PITCH_SENT_DAY: "evar58" //Day of the week the pitch was sent
        };
    }

    getPageJSON(language, market, pageName, uniqueUserID, pinRank) {
        var nus = {};
        nus[this.analyticVariableENUMS.LANGUAGE] = language;
        nus[this.analyticVariableENUMS.MARKET] = market;
        nus[this.analyticVariableENUMS.PAGE_NAME] = pageName;
        if (nuskin.newAccount.UserService.getUser() && (uniqueUserID || pinRank)) {
            nus[this.analyticVariableENUMS.UNIQUE_USER_ID] = uniqueUserID;
            nus[this.analyticVariableENUMS.PIN_RANK] = pinRank;
        }

        return nus;
    }

    setState(state, object, success, failure) {
        if ((this.runConfig.assessmentApp || this.runConfig.phoneGap) && window.hasOwnProperty("ADB")) {
            if (typeof object === 'string'){
                var stateData = {};
                var tempState = state;
                state = object;
                stateData[tempState] = object;
                object = stateData;
            }
            window.ADB.trackState(state, object, success, failure);
        } else {
            // create agelocme DTM object
            nuskin = nuskin || {};
            nuskin.agelocmedtm = {};
            nuskin.agelocmedtm[state] = state;
            if (typeof _satellite !== "undefined") {
                _satellite.track(nuskin.agelocmedtm[state]);
            }
        }
    }

    setAction(action, object, success, failure) {
        if ((this.runConfig.assessmentApp || this.runConfig.phoneGap) && window.hasOwnProperty("ADB")) {
            if (typeof object === 'string'){
                var actionData = {};
                var tempAction = action;
                action = object;
                actionData[tempAction] = object;
                object = actionData;
            }
            window.ADB.trackAction(action, object, success, failure);
        } else {
            // create agelocme DTM object
            nuskin = nuskin || {};
            nuskin.agelocmedtm = {};
            nuskin.agelocmedtm[action] = action;
            if (typeof _satellite !== "undefined") {
                _satellite.track(nuskin.agelocmedtm[action]);
            }
        }
    }

    setProductDTM(sku, qty, price) {
        var productString = ";" + sku + ";" + qty + ";" + price.toFixed(2) + ",";
        //Set the dtm product string
        if (nuskin.newShop) {
            if (this.runConfig.assessmentApp && window.hasOwnProperty("ADB")) {
                window.ADB.trackState("orderDetail", nuskin.newShop.orderDetail || {}, null, null);
                window.ADB.trackState("product", productString, null, null);
                window.ADB.trackState("sku", sku, null, null);
            } else {
                nuskin.newShop.orderDetail = nuskin.newShop.orderDetail || {};
                nuskin.newShop.orderDetail.product = productString;
                nuskin.newShop.orderDetail.sku = sku;
            }
        }
    }

    setCartDTMString(items) {
        var productString = "";
        if (items) {
            for (let i = 0; i < items.length; i++) {
                let price = (items[i].getProduct().getPrice() * items[i].getQty());
                productString += ";" + items[i].sku + ";" + items[i].getQty() + ";" + price.toFixed(2) + ",";
            }
        }
        productString = productString.substr(0, productString.length - 1);
        if (this.runConfig.assessmentApp && window.hasOwnProperty("ADB")) {
            window.ADB.trackState("orderDetail", nuskin.newShop.orderDetail || {}, null, null);
            window.ADB.trackState("cart", productString, null, null);
        } else {
            if (nuskin.newShop) {
                nuskin.newShop.orderDetail = nuskin.newShop.orderDetail || {};
                nuskin.newShop.orderDetail.cart = productString;
            }
        }
    }

    setPageDefaults(language, market, pageName) {
        var user = nuskin.newAccount.UserService.getUser();
        var uniqueUserID = "";
        var pinRank = "";
        if (user && user !== null) {
            uniqueUserID = user.id;
            pinRank = user.highestRank;
        }
        this.setState(this.analyticVariableENUMS.LANGUAGE, language);
        this.setState(this.analyticVariableENUMS.MARKET, market);
        this.setState(this.analyticVariableENUMS.PAGE_NAME, pageName);
        this.setState(this.analyticVariableENUMS.UNIQUE_USER_ID, uniqueUserID);
        this.setState(this.analyticVariableENUMS.PIN_RANK, pinRank);
    }
}

export default new NUSAnalytics();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/nusAnalytics.js
// module id = 306
// module chunks = 0